export const TABS = {
	GENERAL: {
		key: 'GENERAL',
		translationId: 'settings.general',
		inConnectedProjectParent: true,
		financialsInfo: false,
	},
	STATUS: {
		key: 'STATUS',
		translationId: 'common.status',
		inConnectedProjectParent: false,
		financialsInfo: false,
	},
	TASKS: {
		key: 'TASKS',
		translationId: 'common.tasks',
		inConnectedProjectParent: true,
		financialsInfo: false,
	},
	FINANCIALS: {
		key: 'FINANCIALS',
		translationId: 'common.financials',
		inConnectedProjectParent: false,
		financialsInfo: true,
	},
	TEAM: {
		key: 'TEAM',
		translationId: 'common.team',
		inConnectedProjectParent: true,
		financialsInfo: false,
	},
	INTEGRATIONS: {
		key: 'INTEGRATIONS',
		translationId: 'settings_account.section-integrations',
		inConnectedProjectParent: false,
		financialsInfo: false,
	},
};
